export default "__VITE_ASSET__2f3ad77b__"